module.exports = __webpack_public_path__ + "static/media/20ECE7.ff7d4eec.jpg";